import React, { Component, Fragment } from "react";
import Rnd from "react-rnd-rotate";

import html2canvas from "html2canvas";

import objectsList from "./../objectsList";
import objectsList2 from "./../objectsList2";
import objectsList3 from "./../objectsList3";

import {
  Menu,
  Item,
  Separator,
  Submenu,
  MenuProvider,
  contextMenu
} from "react-contexify";

import ContextMenu from "./ContextMenu";
import ObjectsInfo from "./ObjectsInfo";
import {
  readSVG,
  loadScenesFromLocalStorage,
  loadScenesFromStorage
} from "./utils";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Collapse } from "react-collapse";
import PropTypes from "prop-types";
import uuid4 from "uuid4";

const onClick = ({ event, props }) => console.log(event, props);

const flip = () => console.log("fliiped");

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #ddd",
  background: "#f0f0f0",
  marginTop: "50px",
  marginLeft: "50px",
  zIndex: 10
};

const handleTopLeftStyles = {
  width: "10px",
  height: "10px",
  left: "-6px",
  top: "-6px"
};
const handleTopRightStyles = {
  width: "10px",
  height: "10px",
  right: "-6px",
  top: "-6px"
};
const handleBottomRightStyles = {
  width: "10px",
  height: "10px",
  right: "-6px",
  bottom: "-6px"
};
const handleBottomLeftStyles = {
  width: "10px",
  height: "10px",
  bottom: "-6px",
  left: "-6px"
};
const handleTopCenterStyles = {
  width: "10px",
  height: "10px",
  left: "50%",
  top: "-6px",
  marginLeft: "-6px"
};

const handleRightCenterStyles = {
  width: "10px",
  height: "10px",
  right: "-6px",
  marginTop: "-6px"
};
const handleBottomCenterStyles = {
  width: "10px",
  height: "10px",
  bottom: "-6px",
  marginLeft: "-6px"
};
const handleLeftCenterStyles = {
  width: "10px",
  height: "10px",
  left: "-6px",
  marginTop: "-6px"
};
const handleRotateStyles = {
  width: "16px",
  height: "16px",
  left: "50%",
  marginLeft: "-8px",
  border: "none",
  borderRadius: "initial"
};

export default class DesignContainer extends Component {
  constructor() {
    super();

    this.loadScenesFromStorage = loadScenesFromStorage.bind(this);
    this.state = {
      objects: [],
      selected: [],
      sceneActive: true,
      scene: 0,
      // showAllScene: true,
      scenes: [
        {
          name: "Scene 1",
          width: "100",
          height: "100",
          background: "whitesmoke",
          id: `${uuid4()}`,
          objects: [],
          units: "%"
        }
      ],
      showScenes: true,
      clipBoard: {},
      objectsList: [...objectsList]
    };
    this.updateStateFromInput = this.updateStateFromInput.bind(this);
    this.updateSize = this.updateSize.bind(this);
    this.updateBackground = this.updateBackground.bind(this);
  }
  getScenesFromStorage() {
    loadScenesFromStorage(response => {
      if (response) {
        if (response.success) {
          const scenes = response.data;
          if (scenes != null) {
            this.setState({
              scenes
            });
          }
        }
      }
    });
  }
  loadMore() {
    var imageObjects = [...objectsList, ...objectsList2];
    var stateObjList = this.state.objectsList;
    if (stateObjList.length > objectsList.length) {
      imageObjects = [...imageObjects, ...objectsList3];
    }
    this.setState(state => ({
      objectsList: imageObjects
    }));
  }
  updateBackground(color) {
    var scenes = this.state.scenes;
    var scene = scenes[this.state.scene];
    scene.background = color;
    scenes[this.state.scene] = scene;
    this.setState({ scenes });
  }
  componentDidMount() {
    this.getScenesFromStorage();
  }
  addImage(opts) {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let { objects } = scene;
    objects[objects.length] = {
      x: 10,
      y: 10,
      zIndex: 1,
      name: opts.objectName,
      selected: true,
      type: "svg",
      degree: ""
    };
    scene.objects = objects;
    scenes[this.state.scene] = scene;
    this.setState({ scenes, selected: [objects.length] });
  }
  updateSize({ width, height }) {
    var currentScene = this.state.scene;
    currentScene = this.state.scenes[currentScene];
    currentScene.width = width;
    currentScene.units = "px";
    currentScene.height = height;
    var scenes = this.state.scenes;
    scenes[this.state.scene] = currentScene;
    this.setState(state => ({
      scenes
    }));
  }
  handleContextMenu(e) {
    e.preventDefault();
    contextMenu.show({
      id: "object_menu",
      event: e,
      props: {
        object: this.state.scenes[this.state.scene]["objects"][
          e.target.dataset.object
        ],
        key: e.target.dataset.object
      }
    });
  }
  handleSceneContextMenu(e) {
    e.preventDefault();
    if (e.target === e.currentTarget) {
      contextMenu.show({
        id: "scene_menu",
        event: e,
        props: {
          obj: e.target.id
        }
      });
    }
  }
  addScene() {
    const nameLen = this.state.scenes.length;
    var lastScene = this.state.scenes[nameLen - 1];
    var no = parseInt(lastScene.name.split(" ").slice(-1));
    var scenePlate = {
      name: `Scene ${no + 1}`,
      width: "100",
      height: "100",
      background: "grey",
      id: `${uuid4()}`,
      objects: [],
      units: "%"
    };
    this.setState(state => ({
      scenes: [...state.scenes, scenePlate],
      scene: nameLen
    }));
    this.props.updateScene([...this.state.scenes, scenePlate]);
  }
  removeScene(scene) {
    let me = [...this.state.scenes];
    delete me[scene];
    me = [...me];
    var newMe = me.filter(function(e) {
      return e;
    });
    this.setState({
      scenes: newMe,
      scene: 0
    });
    this.props.updateScene([...newMe]);
  }
  showScenes() {
    this.setState(state => ({
      showScenes: !state.showScenes
    }));
    this.props.updateScene(this.state.scenes);
  }
  selectScene(key) {
    this.setState({
      scene: key
    });
    this.props.updateScene(this.state.scenes);
  }
  removeImage(opts) {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;
    delete objects[opts.key];
    scene.objects = objects;
    scenes[this.state.scene] = scene;
    this.setState({ scenes, selected: [] });
  }

  moveTo(opts) {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;

    if (opts.direction === "front") {
      objects[opts.key].zIndex = objects[opts.key].zIndex + 1;
    } else if (opts.direction === "back") {
      objects[opts.key].zIndex =
        objects[opts.key].zIndex > 1 ? objects[opts.key].zIndex - 1 : 1;
    }
    scene.objects = objects;
    scenes[this.state.scene] = scene;
    this.setState({ scenes });
  }

  rotateHandler({ key, degree }) {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;
    // let object = objects[key];
    console.log([key, degree]);
    objects[key].degree = degree;
    scene.objects = objects;
    scenes[this.state.scene] = scene;
    this.setState({ scenes });
  }

  saveImage(opts) {
    const backgroundColor = opts.format === "png" ? null : "#fff";

    html2canvas(document.getElementById("scene"), { backgroundColor }).then(
      function(canvas) {
        const a = document.createElement("a");
        a.href = canvas
          .toDataURL(`image/${opts.format}`)
          .replace(`image/${opts.format}`, "image/octet-stream");
        a.download = `humaaans.${opts.format}`;
        a.click();
      }
    );
  }

  search(e) {
    const searchTerm = e.target.value;

    let filteredResults = [];

    if (searchTerm) {
      objectsList.map(object => {
        if (object.toLowerCase().includes(searchTerm.toLowerCase())) {
          filteredResults.push(object);
        }
      });
    } else {
      filteredResults = objectsList;
    }

    this.setState({
      objectsList: filteredResults
    });
  }

  sceneActive(ev) {
    ev.preventDefault();
    if (ev.target === ev.currentTarget) {
      this.setState({
        sceneActive: true,
        selected: []
      });
    }
    this.props.updateScene(this.state.scenes);
  }

  select(ev) {
    console.log([ev, "hey"]);
    this.setState({ selected: [ev.key], sceneActive: false });
    this.props.updateScene(this.state.scenes);
  }
  onDrag = (k, e, d) => {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;
    var object = objects[k.key];
    object = { ...object, ...d };
    console.log([k, e, d]);
    objects[k.key] = object;
    scene.objects = objects;
    scenes[this.state.scene] = scene;
    this.setState({ scenes: scenes });
  };
  updateResize = (ev, e, direction, ref, delta, position) => {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;
    var object = objects[ev.key];
    console.log([ev, e, direction, ref, delta, position]);
    object = {
      ...object,
      width: parseInt(ref.style.width.replace("px", "")),
      height: parseInt(ref.style.height.replace("px", "")),
      degree: delta.degree,
      ...position
    };
    objects[ev.key] = object;
    scene.objects = [...objects];
    scenes[this.state.scene] = scene;
    this.setState({
      scenes
    });
  };

  updateRotate = ev => {
    console.log([ev, "Rotating"]);
  };

  updateStateFromInput(data) {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    let objects = scene.objects;
    var object = objects[data.id];
    object[data.name] = data.value;
    objects[data.id] = object;
    scene.objects = [...objects];
    scenes[this.state.scene] = scene;
    this.setState({
      scenes
    });
  }

  // Context Menu Functions
  copyToClipBoard(object) {
    this.setState({
      clipBoard: object
    });
  }
  pasteFromClipBoard() {
    let { scenes } = this.state;
    let scene = scenes[this.state.scene];
    if (Object.keys(this.state.clipBoard).length) {
      let objects = [...scene.objects, this.state.clipBoard];
      scene.objects = [...objects];
      scenes[this.state.scene] = scene;
      this.setState({
        scenes
      });
    }
  }
  render() {
    var { scenes } = this.state;
    if (this.state.scene === undefined || this.state.scene == null)
      return <h1>Loading ... current scene</h1>;
    var scene = this.state.scenes[this.state.scene];
    if (!scene) {
      this.setState({
        scene: 0
      });
    }

    const activeScene = this.state.showAllScene ? scenes : [scene];
    console.log([scene, this.state.scene, scenes]);

    if (!scene) return <h1>Loading ... scene</h1>;

    if (!scene.objects) return <h1>Loading ... scene object</h1>;
    if (!this.state.objectsList) return <h1>Loading ... state obj l</h1>;
    return (
      <div className="design-container">
        <div id="left-sidebars" className="sidebar">
          <div className="sidebar-container">
            <Tabs>
              <TabList>
                <Tab>Scene</Tab>
                <Tab>Libraries</Tab>
              </TabList>

              <TabPanel>
                <div className="accordion-scenes">
                  <div className="scenes-header">
                    <div className="scenes-header-expanded">
                      <div className="scenes-title">Scenes</div>
                      <span
                        className="svg-container scenes-caret"
                        onClick={this.showScenes.bind(this)}
                      >
                        {this.state.showScenes ? (
                          <svg
                            className="svg"
                            width="12"
                            height="12"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6.5 8.5l3-3.5h-6l3 3.5z" />
                          </svg>
                        ) : (
                          <svg
                            className="svg"
                            width="12"
                            height="12"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M8.5 6.5L5 3.5v6l3.5-3z" />
                          </svg>
                        )}
                      </span>
                      <div
                        className="scenes-new-btn"
                        onClick={this.addScene.bind(this)}
                      >
                        <span
                          tabIndex="-1"
                          className="svg-container"
                          data-tooltip-text="Add New Page"
                        >
                          <svg
                            className="svg"
                            width="24"
                            height="24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 11V6h1v5h5v1h-5v5h-1v-5H6v-1h5z"
                              fillRule="evenodd"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Collapse isOpened={this.state.showScenes}>
                      <div className="scenes-container">
                        <div className="scenes-container-inner">
                          {this.state.scenes.map((scene, key) => {
                            var sceneSceneClass = "scenes-scene";
                            if (key === this.state.scene) {
                              sceneSceneClass += " active";
                            }
                            return (
                              <Fragment key={key}>
                                <div
                                  className={sceneSceneClass}
                                  data-id={scene.id}
                                  onClick={this.selectScene.bind(this, key)}
                                >
                                  <p className="d-inline">{scene.name}</p>
                                  <button
                                    className="float-right d-inline del-btn"
                                    onClick={this.removeScene.bind(this, key)}
                                    disabled={
                                      this.state.scenes.length > 1
                                        ? false
                                        : true
                                    }
                                  >
                                    <i className="mdi mdi-delete" />
                                  </button>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div id="searchWrapper">
                  <input
                    type="text"
                    id="search"
                    placeholder="Search"
                    onChange={this.search.bind(this)}
                  />
                </div>

                <div id="list" className="assets row m-0">
                  {this.state.objectsList.map((objectName, key) => {
                    return (
                      <Fragment key={key}>
                        <div className="asset">
                          <img
                            alt={objectName}
                            className="asset-img"
                            title={objectName}
                            src={`${objectName}`}
                            onClick={this.addImage.bind(this, { objectName })}
                          />
                        </div>
                      </Fragment>
                    );
                  })}{" "}
                  <button
                    className="ill-button"
                    onClick={this.loadMore.bind(this)}
                  >
                    more
                  </button>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <div id="sceneWrapper">
          {activeScene.map((s, ak) => {
            var sceneStyle = {
              width: `${s.width}${s.units}`,
              height: `${s.height}${s.units}`,
              backgroundColor: s.background
            };
            if (s.units === "%") sceneStyle["position"] = "absolute";
            return (
              <div className="sceneMenu" id="scene_id" key={ak}>
                <div
                  id={"scene-" + this.state.scene}
                  onClick={this.sceneActive.bind(this)}
                  datascene={this.state.scene}
                  style={sceneStyle}
                  className="scene"
                  onContextMenu={this.handleSceneContextMenu.bind(this)}
                >
                  {s.objects.map((object, key) => {
                    if (!object) return null;
                    return (
                      <div
                        // moveTo={this.moveTo}
                        key={key}
                        id="object_menu"
                        style={{}}
                        onContextMenu={this.handleContextMenu.bind(this)}
                      >
                        <Rnd
                          bounds=".scene"
                          minWidth={10}
                          minHeight={10}
                          lockAspectRatio
                          size={{ width: object.width, height: object.height }}
                          position={{
                            x: parseInt(object.x),
                            y: parseInt(object.y)
                          }}
                          className={`${
                            this.state.selected.includes(key) ? "selected" : ""
                          }`}
                          style={{
                            zIndex: object.zIndex,
                            transform: `rotate(${object.degree}deg)`
                          }}
                          default={{
                            x: parseInt(object.x),
                            y: parseInt(object.y),
                            width: object.width,
                            height: object.height
                          }}
                          resizeHandleClasses={{
                            topLeft: "resize-handle-base-class",
                            topRight: "resize-handle-base-class",
                            bottomRight: "resize-handle-base-class",
                            bottomLeft: "resize-handle-base-class",
                            topCenter: "resize-handle-base-class",
                            rightCenter: "resize-handle-base-class",
                            bottomCenter: "resize-handle-base-class",
                            leftCenter: "resize-handle-base-class",
                            rotate: "rotate-handle-base-class"
                          }}
                          resizeHandleStyles={{
                            topLeft: handleTopLeftStyles,
                            topRight: handleTopRightStyles,
                            bottomRight: handleBottomRightStyles,
                            bottomLeft: handleBottomLeftStyles,
                            topCenter: handleTopCenterStyles,
                            rightCenter: handleRightCenterStyles,
                            bottomCenter: handleBottomCenterStyles,
                            leftCenter: handleLeftCenterStyles,
                            rotate: handleRotateStyles
                          }}
                          onDrag={this.onDrag.bind(this, { key })}
                          onDragStop={(e, d) => {
                            var _scene = s;
                            var objects = _scene.objects;
                            var obj = objects[key];
                            obj = { ...obj, ...d };
                            objects[key] = obj;
                            s.objects = objects;
                            var _scenes = scenes;
                            _scenes[this.state.scene] = s;

                            this.setState({ scenes: _scenes });
                          }}
                          onResize={this.updateResize.bind(this, { key })}
                          onRotate={this.updateRotate.bind(this, { key })}
                        >
                          <img
                            className="objSVG"
                            onClick={this.select.bind(this, { key })}
                            data-object={key}
                            src={`${object.name}`}
                            alt={object.name}
                            // height={object.height}
                            // width={object.width}
                            draggable="false"
                          />

                          <div
                            title="Move to back"
                            className="moveToBack"
                            onClick={this.moveTo.bind(this, {
                              direction: "back",
                              key
                            })}
                          >
                            <img src="icons/arrowDown.svg" alt="" />
                          </div>
                          <div
                            title="Move to front"
                            className="moveToFront"
                            onClick={this.moveTo.bind(this, {
                              direction: "front",
                              key
                            })}
                          >
                            <img src="icons/arrowUp.svg" alt="" />
                          </div>
                          <div
                            title="Remove"
                            className="remove"
                            onClick={this.removeImage.bind(this, { key })}
                          >
                            <img src="icons/remove.svg" alt="" />
                          </div>
                        </Rnd>
                      </div>
                    );
                  })}
                  <ContextMenu
                    menuId="object_menu"
                    menu="objects"
                    copyToClipBoard={this.copyToClipBoard.bind(this)}
                    pasteFromClipBoard={this.pasteFromClipBoard.bind(this)}
                    removeImage={this.removeImage.bind(this)}
                    moveTo={this.moveTo.bind(this)}
                    rotateHandler={this.rotateHandler.bind(this)}
                  />
                </div>

                <ContextMenu
                  menuId="scene_menu"
                  menu="scenes"
                  pasteFromClipBoard={this.pasteFromClipBoard.bind(this)}
                />
              </div>
            );
          })}
        </div>
        <div id="right-sidebar" className="objects-info-wrapper sidebar p-2">
          <ObjectsInfo
            updateStateFromInput={this.updateStateFromInput}
            updateSize={this.updateSize}
            updateBackground={this.updateBackground}
            selected={this.state.selected}
            sceneActive={this.state.sceneActive}
            scene={this.state.scene}
            scenes={this.state.scenes}
          />
        </div>
      </div>
    );
  }
}

DesignContainer.protoTypes = {
  updateScene: PropTypes.func
};
